(function (w, d) {
  'use strict';
  if (w.__libasOpenAiStorefrontBridge) return;
  w.__libasOpenAiStorefrontBridge = true;
  var queue = [];
  var timer = null;
  var lastClick = 0;
  var seenOrders = {};

  function flush() {
    timer = null;
    var current = Date.now();
    queue = queue.filter(function (item) { return item.expires > current; });
    var api = w.Shopify && w.Shopify.analytics;
    if (api && typeof api.publish === 'function') {
      queue = queue.filter(function (item) {
        try {
          var result = api.publish(item.name, item.data);
          if (result && typeof result.catch === 'function') result.catch(function () {});
          return result === false;
        } catch (error) { return true; }
      });
    }
    if (queue.length) timer = w.setTimeout(flush, 250);
  }

  function publish(name, data) {
    if (queue.length >= 20) return;
    queue.push({name: name, data: data, expires: Date.now() + 20000});
    if (!timer) timer = w.setTimeout(flush, 0);
  }

  d.addEventListener('click', function (event) {
    var target = event.target;
    if (!event.isTrusted || !target || typeof target.closest !== 'function') return;
    var button = target.closest('.gokwik-checkout button, .gokwik-checkout a, [onclick*="gokwikCheckoutClickFn"]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true' ||
        button.classList.contains('disabled') || button.classList.contains('gokwik-disabled')) return;
    var now = Date.now();
    if (now - lastClick < 1500) return;
    lastClick = now;
    var id = w.crypto && typeof w.crypto.randomUUID === 'function'
      ? w.crypto.randomUUID() : now.toString(36) + '-' + Math.random().toString(36).slice(2);
    publish('libas_openai:checkout_started', {version: 1, source: 'gokwik', event_id: id});
  }, true);

  // Called only from the existing GoKwik Order_Placed_GK handler.
  w.libasOpenAiOrderCreated = function (value) {
    if (typeof value !== 'string' && typeof value !== 'number') return;
    var id = String(value).replace(/^#/, '');
    if (!/^[A-Za-z0-9_-]{1,128}$/.test(id) || /^(undefined|null|0)$/i.test(id) || seenOrders[id]) return;
    seenOrders[id] = true;
    publish('libas_openai:order_created', {version: 1, source: 'gokwik', order_id: id});
  };
})(window, document);
